import {CreditDetailsResponse} from "@/types/service-response";

export default class CreditDetails {
  private constructor (
    readonly id: number,
    readonly createdAt: string,
    readonly kind: string,
    readonly amount: number,
    readonly description: string
  ) {}


  static createFromResponse (responseData: CreditDetailsResponse): CreditDetails {
    return new CreditDetails(
        responseData.id,
        responseData.createdAt,
        responseData.kind,
        responseData.amount,
        responseData.description,
    )
  }

  static createFromResponseList (responseData: CreditDetailsResponse[]): CreditDetails[]{
    return  responseData.map((item: CreditDetailsResponse)=>{
      return new CreditDetails(
          item.id,
          item.createdAt,
          item.kind,
          item.amount,
          item.description,
      )
        }
    )
  }


}